import { createAction } from '@reduxjs/toolkit';
import {
  GET_THERMOSTAT,
  GET_THERMOSTATS,
  UPDATE_DEMO_THERMOSTAT,
  UPDATE_DEMO_THERMOSTAT_STATE,
  UPDATE_ECOBEE_THERMOSTAT,
  UPDATE_THERMOSTAT,
  UPDATE_THERMOSTAT_HVAC_MODE,
  UPDATE_THERMOSTAT_BULK,
  UPDATE_THERMOSTAT_HVAC_MODE_BULK,
  ATTACH_THERMOSTAT_PRESET,
  GET_BUILDING_THERMOSTAT_PRESETS,
  UPDATE_MASTER_THERMOSTAT_CONTROL,
  GET_MASTER_THERMOSTAT_CONTROL,
  UPDATE_BUILDING_THERMOSTAT_PRESETS,
  CREATE_THERMOSTAT_PRESET
} from '../constants';

export const getThermostat = createAction(GET_THERMOSTAT);
export const searchThermostats = createAction(GET_THERMOSTATS);
export const updateThermostat = createAction(UPDATE_THERMOSTAT);
export const updateThermostatBulk = createAction(UPDATE_THERMOSTAT_BULK);
export const updateEcobeeThermostat = createAction(UPDATE_ECOBEE_THERMOSTAT);
export const updateThermostatHvacMode = createAction(UPDATE_THERMOSTAT_HVAC_MODE);
export const updateThermostatHvacModeBulk = createAction(UPDATE_THERMOSTAT_HVAC_MODE_BULK);
export const createThermostatPreset = createAction(CREATE_THERMOSTAT_PRESET);
export const attachThermostatPreset = createAction(ATTACH_THERMOSTAT_PRESET);

// Demo actions (to be replaced)
export const updateDemoThermostat = createAction(UPDATE_DEMO_THERMOSTAT);
export const updateDemoThermostatState = createAction(UPDATE_DEMO_THERMOSTAT_STATE);

// Building thermostat presets actions
export const getBuildingThermostatPresets = createAction(GET_BUILDING_THERMOSTAT_PRESETS);
export const getMasterThermostatControl = createAction(GET_MASTER_THERMOSTAT_CONTROL);
export const updateThermostatMasterControl = createAction(UPDATE_MASTER_THERMOSTAT_CONTROL);
export const updateBuildingThermostatPresets = createAction(UPDATE_BUILDING_THERMOSTAT_PRESETS);
